/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getTelegramOidcLinkResponseSchema = z.object({
  linked: z.boolean(),
  telegramUserId: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  scope: z.string().nullable(),
  canMessage: z.boolean(),
});

export type IGetTelegramOidcLinkResponse = z.infer<typeof getTelegramOidcLinkResponseSchema>;
